/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";
import colors from "./colors";

export const dividerCss = css`
  width: 100%;
  border-top: 1px solid ${colors.textGreyOpacity25};
`;
